module.exports = __webpack_public_path__ + "static/overview-phone-65ae42a13bb2a74f6550e65aeb513ef1.png";